import { render, staticRenderFns } from "./InfoDashboard.vue?vue&type=template&id=f58bae9a&"
import script from "./InfoDashboard.vue?vue&type=script&lang=js&"
export * from "./InfoDashboard.vue?vue&type=script&lang=js&"
import style0 from "./InfoDashboard.vue?vue&type=style&index=0&id=f58bae9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports